// hooks/useScrollPersistence.js
import { useEffect, useCallback, useRef } from "react";

export const useScrollPersistence = (ref, key, restoreTrigger) => {
  const restoredRef = useRef(false);

  useEffect(() => {
    if (restoredRef.current) return;

    const el = ref.current;
    const saved = sessionStorage.getItem(key);

    if (!el || saved === null) return;

    const target = Number(saved);

    const tryRestore = () => {
      // スクロール可能になるまで待つ
      if (el.scrollHeight > el.clientHeight) {
        el.scrollTop = target;
        restoredRef.current = true;
        console.log(`✅ scroll restored: ${key} = ${target}`);
      } else {
        // まだ高さ足りない → 次フレーム
        requestAnimationFrame(tryRestore);
      }
    };

    requestAnimationFrame(tryRestore);
  }, [ref, key, restoreTrigger]);

  const saveScroll = useCallback(() => {
    const el = ref.current;
    if (!el) return;

    sessionStorage.setItem(key, el.scrollTop.toString());
    console.log(`💾 scroll saved: ${key} = ${el.scrollTop}`);
  }, [ref, key]);

  return { saveScroll };
};
